export default "__VITE_ASSET__B4IeHT0p__"